import { events, INIT_EVENT, INIT_EVENT_FINISH } from '@/events-bus';
import { editor } from '@/instance';
import { useAdjustCollapseModel } from '@/store/collapse-models/adjust-collapse-model';
import { useCollapseModel } from '@/store/collapse-models/collapse-model';
import { useNavigationCollapseModel } from '@/store/collapse-models/navigation-collapse-model';
import { useImageEditorModel } from '@/store/models/image-editor-model';
import { useRecordModel } from '@/store/models/record-model';
import { useSaveInfoModel } from '@/store/models/save-model';
import { useSearchModel } from '@/store/models/search-model';
import { useSvipWatermarkModel } from '@/store/models/svip-water-mask-model';
import { useTemplateModel } from '@/store/models/template-model';

export const useInitEditorStore = () => {
    const destroys: (() => void)[] = [
        useTemplateModel((actions) => actions.destroy),
        useCollapseModel((actions) => actions.destroy),
        useSvipWatermarkModel((actions) => actions.destroy),
        useRecordModel((actions) => actions.destroy),
        useSaveInfoModel((actions) => actions.destroy),
        useSearchModel((actions) => actions.destroy),
        useNavigationCollapseModel((actions) => actions.destroy),
        useImageEditorModel((actions) => actions.destroy),
        useAdjustCollapseModel((actions) => actions.destroy),
    ];

    return {
        init() {
            events.emit(INIT_EVENT);
            editor.init();
            destroys.forEach((init) => {
                init();
            });
            events.emit(INIT_EVENT_FINISH);
        },
    };
};
